<script lang="ts" setup>
import type { IProps } from './PartnershipsItems.types'
import PartnershipsItem from './PartnershipsItem.vue'

defineProps<IProps>()

</script>

<template>
  <div class="partnerships-items">
    <PartnershipsItem
      v-for="(item, index) in items"
      :key="`partnerships-item-${index}`"
      :item="item"
    />
  </div>
</template>

<style lang="scss" scoped>
.partnerships-items {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 3.2rem;
}

@include atXS {
  .partnerships-items {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
